import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export const useParentStyles = (src?: Document, target?: Document | null) => {
  useIsomorphicLayoutEffect(() => {
    if (!src || !target) {
      return;
    }
    // copy all stylesheets from parent
    const links = src.querySelectorAll('link[rel=stylesheet]');
    links.forEach((link) => {
      target.head.appendChild(link.cloneNode());
    });

    // add top-level iframe document style reset
    const resetStyles = document.createElement('style');
    resetStyles.innerHTML = 'html,body { margin: 0; padding: 0; }';
    target.head.appendChild(resetStyles);
  }, [src, target]);
};
